import { Button } from '../../../atoms/Button';
import { Typography } from '../../Typography';

interface ExamFeedbackFooterProps {
  onRevisionListClick: () => void;
}

export default function ExamFeedbackFooter({
  onRevisionListClick,
}: ExamFeedbackFooterProps) {
  return (
    <footer
      className={`
      bg-color-lightest font-noto fixed bottom-0 left-0
        h-28 w-full flex-col items-center justify-center gap-sm border-t-hairline
        border-t-mono-100 px-8 py-5 text-center shadow-level-2 xs:hidden
        md:h-20 md:flex-row md:gap-xl lg:flex
      `}
    >
      <Typography
        weight='bold'
        className='text-sm md:w-[377px] md:text-left lg:w-auto lg:text-center lg:text-base'
      >
        Os assuntos que você errou nesse simulado já entraram na sua lista de
        revisão. Confira!
      </Typography>
      <Button onClick={onRevisionListClick}>Acessar lista de revisões</Button>
    </footer>
  );
}
